// eslint-disable-next-line import/no-internal-modules
import config from '../../content/config/settings.json'

export function getConfigData() {
  return config
}
